import clsx from 'clsx'
import React from 'react'

import { SearchIcon } from '@/widgets/Header/ui/header-personal-links/assets/SearchIcon'

import { useModalState } from '@/features/search/hooks/use-modal-state'
import { HeaderSearchModal } from '@/features/search/ui/header-search-modal/header-search-modal'

import { Button } from '@/shared/ui'

import cl from './style.module.scss'

interface HeaderSearchButtonProps {
	exCl: string
}

export const HeaderSearchButton = (props: HeaderSearchButtonProps) => {
	const { exCl = '' } = props
	const { open: openSearchModal, close: closeSearchModal, isOpen: isSearchModalActive } = useModalState()
	return (
		<>
			<Button theme={'clear'} className={clsx(cl.btn, cl.btn_search, exCl)} onClick={openSearchModal}>
				<SearchIcon />
				<span style={{ fontSize: `0`, lineHeight: `0` }}>Поиск</span>
			</Button>
			{isSearchModalActive && <HeaderSearchModal onClose={closeSearchModal} />}
		</>
	)
}
